export function formatMoney(value) {
  if (value === null || value === undefined) return "—";

  const num = Math.round(value);
  return "€ " + num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
}
